import { ImageHelper, type IMediaModel } from "@nf/common";
import cx from "classnames";

import LandingPageCover from "./LandingPageCover";

import styles from "./LandingPageCoverGroup.module.scss";

interface LandingPageCoverGroupProps {
  assets: IMediaModel[];
  className?: string;
  startIndex?: number;
  visible: boolean;
}

const LandingPageCoverGroup = ({
  assets,
  className,
  startIndex = 0,
  visible,
}: LandingPageCoverGroupProps) => (
  <div className={className}>
    {assets?.map((media, index) => {
      const imageUrl = ImageHelper.getPosterImageUrl(media.Images);

      if (!imageUrl) {
        return null;
      }

      return (
        <LandingPageCover
          key={media.Id}
          src={imageUrl}
          className={cx(
            styles.cover,
            styles[`cover${startIndex + index + 1}`],
            {
              [styles.visible]: visible,
            }
          )}
        />
      );
    })}
  </div>
);

export default LandingPageCoverGroup;
